/**
 * Transforms Storyblok asset URLs from `a.storyblok.com` to `assets.yoco.com`
 *
 * This is their official reccomendation for using a custom assets domain:
 * @see https://www.storyblok.com/tp/set-up-a-custom-assets-domain-using-amazon-cloudfront#replace-the-domain-in-your-application
 *
 * Assets domain setup can be found here:
 * @see https://gitlab.com/yoco/devops/infrastructure-as-code/yoco-cloudflare-as-code/-/merge_requests/189/diffs
 */
export function transformAssetSrc(src: string): string {
  if (!src || typeof src !== "string") {
    return src
  }

  try {
    const urlToParse = src.startsWith("//") ? `https:${src}` : src
    const url = new URL(urlToParse)
    if (url.hostname === "a.storyblok.com") {
      url.hostname = "assets.yoco.com"
      return url.href
    }
  } catch (error) {
    console.warn("Failed to parse URL for transformation:", src, error)
  }

  return src
}
